import { createContext, useContext, useState, ReactNode, useCallback, useMemo } from "react";

interface SidebarContextType {
  showSidebar: boolean;
  setShowSidebar: (value: boolean) => void;
  toggleSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [showSidebar, setShowSidebarState] = useState(false);

  const setShowSidebar = useCallback((value: boolean) => setShowSidebarState(value), []);
  const toggleSidebar = useCallback(() => setShowSidebarState(prev => !prev), []);
  const value = useMemo(
    () => ({ showSidebar, setShowSidebar, toggleSidebar,}),
    [showSidebar, setShowSidebar, toggleSidebar]
  )

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
